<template>
  <div class="batteryTem" style="height: 100%;">
    <el-row :gutter="40">
      <div v-for="(item,index) in list" :key="index">
        <el-col v-if="item.isShow" :lg="12" :sm="24" :xs="24" class="card-panel-col myCol">

          <div v-if="item.key=='current'" class="attr">{{ statuArr[statu] }} ：</div>
          <div v-if="item.key!='current'" class="attr">{{ item.attr }} ：</div>
          <div class="currentVal">
            <span v-if="item.key!='relayStatus'">{{ item.currentValZh }}</span>
            <span>&nbsp;{{ item.unit }}</span>
            <el-radio v-if="item.key=='relayStatus'" v-model="item.currentVal" :disabled="true" :label="0" style="margin-right:20px;" @change="change($event)">{{ $t('AllDevices.Open') }}</el-radio>
            <el-radio v-if="item.key=='relayStatus'" v-model="item.currentVal" :disabled="true" :label="1" @change="change($event)">{{ $t('AllDevices.Close') }}</el-radio>
          </div>
          <el-button v-if="item.key=='current'||item.key=='auxCurrent'" class="calBtn" size="mini" type="primary" @click="submint('currentZero',item.key)">{{ $t('AllDevices.SetZero') }}</el-button>
          <el-button v-if="item.key!='current'&&item.key!='auxCurrent'&&item.key!='hall'&&item.key!='shunt'" class="calBtn" size="mini" type="primary" @click="calibration(item.key)">{{ $t('tagInput.set') }}
          </el-button>
          <el-button v-if="item.key=='voltageRaw'||item.key=='hall'||item.key=='shunt'" class="calBtn" size="mini" type="primary" @click="submint(item.key,item.key)">{{ $t('AllDevices.CalibZero') }}</el-button>
          <i v-if="item.key=='updateIndex'" class="el-icon-question" @mouseover="isShowIdQPop=true" @mouseout="isShowIdQPop=false" />
          <div v-if="isShowIdQPop&&item.key=='updateIndex'" class="infoPop">
            <p>{{ $t('AllDevices.updateIndex') }}</p>
          </div>
        </el-col>
      </div>
      <el-col v-if="$store.state.isAdmin" :lg="12" :sm="24" :xs="24" class="card-panel-col myCol">
        <div class="attr">{{ $t('AllDevices.Delete') }}：</div>
        <el-button class="calBtn" size="mini" type="primary" @click="submint('deleteAllData')">
          {{ $t('AllDevices.DeleteAllData') }}</el-button>
        <i class="el-icon-question" style="margin: 0 20px 0 -18px;" @mouseover="isShowDeleteQPop=true" @mouseout="isShowDeleteQPop=false" />
        <div v-if="isShowDeleteQPop" class="infoPop">
          <p>{{ $t('AllDevices.deleteDetail') }}</p>
        </div>
        <el-button class="calBtn" size="mini" type="primary" @click="submint('deleteHistoryData')">
          {{ $t('AllDevices.DeleteRecord') }}</el-button>
      </el-col>

      <!-- <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col myCol">
        <div v-if="isShowBtnWarp" class="btnWarp">
          <el-input v-model="calObj.soc" class="inp" :placeholder="$t('warningSet.Pleaseenter')" @input="change($event)" />
          <el-button size="mini" @click="isShowBtnWarp=false">{{ $t('button.Cancel') }}</el-button>
          <el-button class="filter-item" type="primary" size="mini">{{ $t('button.Submit') }}</el-button>
        </div>
      </el-col> -->
    </el-row>

  </div>
</template>

<script>
import { yhubControl } from '@/api/allDevice'
import { howLongAgo } from '@/utils/updateTime.js'
import i18n from '@/i18n'
export default {
  components: {
  },
  props: {
    lastRecordObj: {
      type: Object,
      default: () => { }
    },
    mcuId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      calObj: {

      },
      list: [
        { key: 'soc', attr: i18n.t('warningPage.SOC'), currentVal: null, currentValZh: null, unit: '%' },
        { key: 'soh', attr: i18n.t('warningPage.SOH'), currentVal: null, currentValZh: null, unit: '%' },
        { key: 'voltageRaw', attr: i18n.t('basicinfo.Voltage'), currentVal: null, currentValZh: null, unit: 'V' },
        { key: 'auxBatVol', attr: i18n.t('BondOrUpdateDevice.AuxVolAcquisition'), currentVal: null, currentValZh: null, unit: 'V' },
        { key: 'chargedah', attr: i18n.t('basicinfo.Charged'), currentVal: null, currentValZh: null, unit: 'Ah' },
        { key: 'usedah', attr: i18n.t('basicinfo.DisCharged'), currentVal: null, currentValZh: null, unit: 'Ah' },
        { key: 'chargingWh', attr: i18n.t('basicinfo.Charged') + '(kWh)', currentVal: null, currentValZh: null, unit: 'kWh' },
        { key: 'usingWh', attr: i18n.t('basicinfo.DisCharged') + '(kWh)', currentVal: null, currentValZh: null, unit: 'kWh' },
        { key: 'updateIndex', attr: 'updateIndex', currentVal: null, currentValZh: null, unit: '' },
        { key: 'relayStatus', attr: i18n.t('AllDevices.RelayStatus'), currentVal: null, currentValZh: null, unit: '' },
        { key: 'current', attr: i18n.t('AllDevices.Current'), currentVal: null, currentValZh: null, unit: 'A' },
        { key: 'auxCurrent', attr: i18n.t('BondOrUpdateDevice.currentCollection'), currentVal: null, currentValZh: null, unit: 'A' },
        { key: 'hall', attr: 'HALL', currentVal: null, currentValZh: null, unit: '' },
        { key: 'shunt', attr: 'SHUNT', currentVal: null, currentValZh: null, unit: '' }
      ],
      selectAttr: null,
      isShowCalibration: false,
      statu: 0, // 充，放，空闲
      statuArr: [i18n.t('AllDevices.Current'), i18n.t('AllDevices.ChargeCurrent'), i18n.t('AllDevices.DischargeCurrent')], // 充，放，空闲
      isShowIdQPop: false,
      isShowDeleteQPop: false
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.statuArr = [i18n.t('AllDevices.Current'), i18n.t('basicinfo.Charged'), i18n.t('basicinfo.DisCharged')] // 充，放，空闲
      this.list.forEach(v => {
        switch (v.key) {
          case 'soc': v.attr = i18n.t('warningPage.SOC'); break
          case 'soh': v.attr = i18n.t('warningPage.SOH'); break
          case 'voltageRaw': v.attr = i18n.t('basicinfo.Voltage'); break
          case 'auxBatVol': v.attr = i18n.t('BondOrUpdateDevice.AuxVolAcquisition'); break
          case 'chargedah': v.attr = i18n.t('basicinfo.Charged'); break
          case 'usedah': v.attr = i18n.t('basicinfo.DisCharged'); break
          case 'chargingWh': v.attr = i18n.t('basicinfo.Charged') + '(kWh)'; break
          case 'usingWh': v.attr = i18n.t('basicinfo.DisCharged') + '(kWh)'; break
          // case 'updateIndex':v.attr=i18n.t('basicinfo.Voltage');break;
          case 'relayStatus': v.attr = i18n.t('AllDevices.RelayStatus'); break
          case 'current': v.attr = i18n.t('AllDevices.Current'); break
          case 'auxCurrent': v.attr = i18n.t('BondOrUpdateDevice.currentCollection'); break
        }
      })
    },
    // list: {
    //   handler(newValue, oldValue) {
    //     this.list = newValue
    //     this.listFn()
    //   },
    //   deep: true
    //   // immediate: true
    // },
    lastRecordObj: {
      handler(newValue, oldValue) {
        console.log('newValue--lastRecordData', newValue)
        this.lastRecordObj = newValue
        this.listFn()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.listFn()
  },
  methods: {
    change(e) {
      this.$forceUpdate()
    },
    calibration(key) {
      this.isShowCalibration = true
      var obj = {}
      this.list.forEach(v => {
        obj[v.key] = v.currentValZh
      })
      this.list.forEach(v => {
        if (v.key == key) this.calObj = v
        if (v.key == 'chargedah' || v.key == 'usedah' || v.key == 'chargingWh' || v.key == 'usingWh') {
          this.calObj.obj = obj
        }
      })
      if (key == 'relayStatus' && this.lastRecordObj.relayStatus == 1) {
        this.calObj.popStartDateOld = this.lastRecordObj.start * 1000
        this.calObj.popEndDateOld = this.lastRecordObj.end * 1000
      }
      this.$emit('calibrationClick', this.calObj)
    },
    submint(val, key) {
      var confirmInfo = ''
      var cmd = null
      if (val == 'deleteAllData') {
        confirmInfo = i18n.t('AllDevices.ConfirmDelete')// '确定删除所有数据吗?'
        cmd = 5
      } else if (val == 'deleteHistoryData') {
        confirmInfo = i18n.t('AllDevices.sureDelete')// '确定删除设备记录吗?'
        cmd = 13
      } else if (val == 'voltageRaw') {
        confirmInfo = i18n.t('AllDevices.VCalibZero')// '确定将电压校准值清零吗?'
        cmd = 14
      } else if (val == 'hall') {
        confirmInfo = i18n.t('AllDevices.hallCalibZero')// '确定将HALL校准值清零吗?'
        cmd = 15
      } else if (val == 'shunt') {
        confirmInfo = i18n.t('AllDevices.shuntCalibZero')// '确定将SHUNT校准值清零吗?'
        cmd = 16
      } else {
        confirmInfo = i18n.t('AllDevices.ConfirmSetZero')// '确定将电流置零吗?'
        cmd = key == 'current' ? 7 : 11
      }
      this.$confirm(confirmInfo, '', {
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        var param = {
          'cmd': cmd,
          'mcuId': this.mcuId,
          'value': ''
        }
        console.log('param------', param)
        yhubControl(param).then(res => {
          if (res.resultCode == 1001) {
            this.$message({
              type: 'success',
              message: i18n.t('AllDevices.submitP')
            })
            this.isShowCalibration = false
          }
        })
      }).catch(() => { })
    },
    listFn() {
      console.log('calibration-lastRecordObj--', this.lastRecordObj)
      this.list.forEach(v => {
        if (this.$store.state.isAdmin) {
          v.isShow = true
        } else {
          if (v.key == 'soc' || v.key == 'voltageRaw' || v.key == 'auxBatVol' || v.key == 'current' || v.key == 'auxCurrent') {
            v.isShow = true
          } else {
            v.isShow = false
          }
        }
        for (var attr in this.lastRecordObj) {
          if (v.key == attr) {
            v.currentVal = this.lastRecordObj[attr]
            if (attr == 'soc' || attr == 'soh') {
              v.currentValZh = Math.round(this.lastRecordObj[attr] / 100)
            } else if (attr == 'voltageRaw' || attr == 'auxBatVol' || attr == 'auxCurrent' || attr == 'chargedah' || attr == 'usedah') {
              v.currentValZh = (this.lastRecordObj[attr] / 100).toFixed(2)
            } else if (attr == 'chargingWh' || attr == 'usingWh') {
              v.currentValZh = (this.lastRecordObj[attr] / 100000).toFixed(2)
            } else if (attr == 'relayStatus') {
              v.currentValZh = this.lastRecordObj[attr] == 1 ? 'On' : 'Off'
            } else {
              v.currentValZh = (this.lastRecordObj[attr] || this.lastRecordObj[attr] == 0) ? this.lastRecordObj[attr] : '--'
            }
          }
        }
        if (v.key == 'current') {
          var cur = (this.lastRecordObj.current || this.lastRecordObj.current == 0) ? this.lastRecordObj.current : this.lastRecordObj.currentCharging - this.lastRecordObj.currentUsing
          if (!cur && cur != 0) {
            this.statu = 0
            v.currentValZh = ''
          } else if (cur == 0) {
            this.statu = v.currentValZh = 0
          } else {
            this.statu = cur > 0 ? 1 : 2
            v.currentValZh = cur > 0 ? (cur / 100).toFixed(2) : -(cur / 100).toFixed(2)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.myCol {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
  position: relative;
}
.attr {
  // width:150px;
  text-align: left;
}
.currentVal {
  // width:150px;
  text-align: left;
  display: flex;
  margin-right: 30px;
}
.calBtn {
  margin-right: 20px;
}
.inp {
  width: 100px !important;
  margin-right: 20px;
}
.btnWarp {
  display: flex;
}
.el-radio {
  margin-right: 0px;
}
.calibrationDialog {
  position: relative;
  z-index: 999999;
}
.el-icon-question {
  margin-left: -15px;
}
.infoPop {
  display: inline-block;
  background: white;
  padding: 14px;
  vertical-align: top;
  -webkit-box-shadow: 1px 1px 5px #ccc;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  bottom: 35px;
  max-width: 100%;
  right: 0;
  width: auto;
}
</style>

